var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0267bade31c4154d12502ff4043f48eb.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27c4e27a75cc633b85934c397c8f49ab.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2ac1645b721aef000f8e7a2d0471ba5f.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/334998c0382f580860b852449e37a490.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4c40f03bde5985520d737171ef09b51a.js').default;
var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6295a016be91531478de2acd9e4701ce.js').default;
var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6e99a650f64094cf61d6d95fe75ca0ce.js').default;
var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/75c91f55956629cda073a2579bffed6e.js').default;
var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8a9c11cd2be419675e028d28733b7ad3.js').default;
var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99e6db3edf41eac1c248ea0eea51bc26.js').default;
var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d3f5c2771b64a2900d9011ed98bba363.js').default;
var scope_11 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d88b3b067c3a2983f005af4d4334809d.js').default;
var scope_12 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcb18912d8540d0cefea3e16e42740ad.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    